import { atom } from 'jotai'
import { poisAtom, tagsAtom } from './mapAtoms.ts'

export type TagId = string | number

export const searchQueryAtom = atom('')

export const activeTagIdsAtom = atom<Array<TagId>>([])

export const activeTagsAtom = atom((get) => {
    const activeTagIds = get(activeTagIdsAtom)
    const tags = get(tagsAtom)

    return tags.filter((tag) => activeTagIds.some((tagId) => String(tagId) === String(tag.id)))
})

export const filteredPoisAtom = atom((get) => {
    const query = get(searchQueryAtom).trim().toLowerCase()
    const activeTagIds = get(activeTagIdsAtom)

    return get(poisAtom).filter((poi) => {
        if (query && !poi.title.toLowerCase().includes(query)) {
            return false
        }

        return activeTagIds.every((tagId) => poi.tags.some((tag) => String(tag.id) === String(tagId)))
    })
})

export const isFilteringAtom = atom((get) => {
    return get(searchQueryAtom).trim().length > 0 || get(activeTagIdsAtom).length > 0
})

export const hasFilterResultsAtom = atom((get) => {
    return get(isFilteringAtom) && get(filteredPoisAtom).length > 0
})

export const setSearchQueryAtom = atom(null, (_get, set, query: string) => {
    set(searchQueryAtom, query)
})

export const toggleTagFilterAtom = atom(null, (get, set, tagId: TagId) => {
    const activeTagIds = get(activeTagIdsAtom)
    const tagIsActive = activeTagIds.some((activeTagId) => String(activeTagId) === String(tagId))

    set(
        activeTagIdsAtom,
        tagIsActive
            ? activeTagIds.filter((activeTagId) => String(activeTagId) !== String(tagId))
            : [...activeTagIds, tagId]
    )
})

export const setActiveTagIdsAtom = atom(null, (_get, set, tagIds: Array<TagId>) => {
    set(activeTagIdsAtom, tagIds)
})

export const clearFiltersAtom = atom(null, (_get, set) => {
    set(searchQueryAtom, '')
    set(activeTagIdsAtom, [])
})
